import {PonyExpress} from './PonyExpress';

type AppBootOverlayProps = {
  /** A status line under the rider, for the moments that need words ("Signing out"). None by default: the rider alone. */
  text?: string;
};

/**
 * Full-viewport boot/transition overlay.
 *
 * Mirrors the persistent #app-loader in index.html (the same rider on white)
 * so users see one continuous loading screen across boot, lazy-route Suspense
 * fallbacks, and sign-out — never a flash to a different spinner or background.
 */
export default function AppBootOverlay({text}: AppBootOverlayProps) {
  return (
    <div className="flex h-screen items-center justify-center bg-white">
      <div className="flex flex-col items-center gap-6">
        <PonyExpress size={160} />
        {text && (
          <span className="text-sm font-medium tracking-[0.15em] text-neutral-500">
            {text}
          </span>
        )}
      </div>
    </div>
  );
}
